import { JadeArrayReturn } from './jade-types';

/**
 * Extracts the object array from a JadeArrayReturn object, which is a Jade-returned object with a $values property,
 * which is an array of objects.
 * @param coll
 * @returns
 */
export const extractJadeArrayReturn = <T>(coll: JadeArrayReturn<unknown>) => {
	return (coll?.$values || []) as T[];
};
